import PassWord from "../../../Components/InputFields/PassWord";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import Back from "./Back";

const DEFAULT_SIGNUP_DATA = {
  password: "",
  password_again: "",
};

export default function ContainerSignUpPhone({
  text,
  subtext,
  signupData,
  setSignupData,
  setStep,
}) {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [localSignupData, setLocalSignupData] = useState(DEFAULT_SIGNUP_DATA);
  const formData = signupData || localSignupData;
  const updateSignupData = setSignupData || setLocalSignupData;
  const [passwordBlur, setPasswordBlur] = useState(false);
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordAgainBlur, setPasswordAgainBlur] = useState(false);
  const [passwordAgainValid, setPasswordAgainValid] = useState(true);
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");

  function isValidPassword(password) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    return regex.test(password);
  }

  useEffect(() => {
    setPasswordValid(isValidPassword(formData.password));
    setPasswordAgainValid(formData.password === formData.password_again);
  }, [formData.password, formData.password_again]);

  useEffect(() => {
    if (fieldsRequired) {
      setHasError(true);
      setError("لطفا تمامی فیلدها را پر کنید");
    } else if (!passwordAgainValid && passwordAgainBlur) {
      setHasError(true);
      setError("رمز های عبور مطابقت ندارند");
    } else {
      setHasError(false);
    }
  }, [
    fieldsRequired,
    passwordAgainValid,
    passwordAgainBlur,
  ]);

  const handlePasswordChange = (e) => {
    updateSignupData((previousData) => ({
      ...DEFAULT_SIGNUP_DATA,
      ...previousData,
      password: e.target.value,
    }));
    setFieldsRequired(false);
  };

  const handlePasswordAgainChange = (e) => {
    updateSignupData((previousData) => ({
      ...DEFAULT_SIGNUP_DATA,
      ...previousData,
      password_again: e.target.value,
    }));
    setFieldsRequired(false);
  };

  const handleNextStep = (e) => {
    e.preventDefault();

    if (!formData.password || !formData.password_again) {
      setFieldsRequired(true);
      return;
    }

    setPasswordBlur(true);
    setPasswordAgainBlur(true);

    if (!passwordValid || !passwordAgainValid) {
      return;
    }

    setFieldsRequired(false);
    if (setStep) {
      setStep(3);
    }
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            {text}
          </h1>
          <Back onClick={() => setStep && setStep(1)} />
        </div>
        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          {subtext}
        </span>
      </div>

      <div>
        <form className="flex flex-col gap-5" onSubmit={handleNextStep}>
          <PassWord
            placeholder="رمز عبور"
            id="password"
            formValue={formData.password}
            formOnChange={handlePasswordChange}
            passwordBlur={passwordBlur}
            setPasswordBlur={setPasswordBlur}
            passwordValid={passwordValid}
            hasPassStrength={true}
          />
          <PassWord
            placeholder="تکرار رمز عبور"
            id="password_again"
            formValue={formData.password_again}
            formOnChange={handlePasswordAgainChange}
            passwordBlur={passwordAgainBlur}
            setPasswordBlur={setPasswordAgainBlur}
            passwordValid={passwordAgainValid}
          />
          <GradientBlue
            type="submit"
            value="مرحله بعدی"
            onClick={handleNextStep}
          />
        </form>
        {hasError && (
          <p className="text-amber-400 text-sm font-extralight mt-1">{error}</p>
        )}
      </div>
    </div>
  );
}
